import React from 'react';
import EmailSignatureGenerator from './components/EmailSignatureGenerator';

function App() {
    return (
        <div className="App">
            <EmailSignatureGenerator />
        </div>
    );
}

export default App;